import { useMemo } from 'react'
import { usePermissions } from '../context/PermissionContext'
import { useEntitlements } from '../context/EntitlementContext'
import {
  useIntegrationSummaryRegistered as useIntegrationSummary,
} from '../featureHooks'
import { buildAppNavigation } from '../../../../shared/appNavigation'

export function isNavigationItemActive(navigationItem, pathname) {
  if (navigationItem.activePrefixes) {
    return navigationItem.activePrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
  }
  return pathname === navigationItem.path
}

/** The permission, entitlement and integration inputs the menu is built from. */
export function useNavigationPolicy() {
  const { canRead, isAdmin, isGlobalAdmin, loading: permissionLoading } = usePermissions()
  const { isFeatureEnabled, showLicensePage, loading: entitlementLoading } = useEntitlements()
  const {
    summary: integrationSummary,
    loading: integrationSummaryLoading,
    error: integrationSummaryError,
  } = useIntegrationSummary()

  return useMemo(() => ({
    canRead, isAdmin, isGlobalAdmin, isFeatureEnabled, showLicensePage, integrationSummary, integrationSummaryError, integrationSummaryLoading, permissionLoading, entitlementLoading,
  }), [
    canRead,
    entitlementLoading,
    integrationSummary,
    integrationSummaryError,
    integrationSummaryLoading,
    isAdmin,
    isFeatureEnabled,
    isGlobalAdmin,
    permissionLoading,
    showLicensePage,
  ])
}

/**
 * Single permission and entitlement aware navigation model shared by both
 * shells. Presentation may change, but route visibility never forks by skin.
 */
export default function useAppNavigation({ pendingDecisions = null } = {}) {
  const policy = useNavigationPolicy()
  return useMemo(() => {
    return buildAppNavigation({ ...policy, pendingDecisions })
  }, [pendingDecisions, policy])
}
